import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Nav } from '@mashvisor/design-system';
import { initNavigationScript } from '@mashvisor/design-system';
import Helmet from 'react-helmet';
import Cookies from 'js-cookie';
import { StaticQuery, graphql } from 'gatsby';
import { requestDemo } from '../utils/calendly';
const jwt_decode = require('jwt-decode');

const getUserInfoFromCookie = () => {
  try {
    const token = Cookies.get('squanchy');
    if (token) {
      const userInformation = jwt_decode(token);
      if (userInformation.user) {
        return { ...userInformation.user, token };
      }
    }
  } catch (error) {}
  return null;
};

const getUserPlan = async ({ apiBaseUrlV1 }) => {
  const userInfo = getUserInfoFromCookie();

  if (userInfo) {
    const userId = userInfo.id;
    const token = userInfo.token;
    const url = `${apiBaseUrlV1}/user/${userId}/permissions?_t=QcG6kP3yDnUHD67hWAAQyqrDdFm4gBPW`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (data && data.content && data.content.subscription_plan) {
      return {
        subscriptionPlan: data.content.subscription_plan,
        subscriptionStatus: data.content.status,
      };
    }
  }
  return {
    subscriptionPlan: '',
    subscriptionStatus: '',
  };
};

function signInWithGoogleSDK() {
  window.mv_signInWithGoogleSDK = window.mv_signInWithGoogleSDK || [];
  window.mv_signInWithGoogleSDK.push(arguments);
}
const NavWrapper = ({ environment, apiBaseUrlV1 }) => {
  const [userPlan, setUserPlan] = useState();
  const [planStatus, setPlanStatus] = useState();
  const isProd = !environment || environment === 'production';

  const onDemoClick = () => {
    requestDemo();
  };

  const onContactSupportClick = () => {
    window.Intercom('showNewMessage');
  };

  const handleLogin = () => {
    try {
      const token = Cookies.get('squanchy');
      if (token) {
        const userInformation = jwt_decode(Cookies.get('squanchy'));
        if (userInformation.user && userInformation.user.subscription_plan) {
          setUserPlan(userInformation.user.subscription_plan);
          return;
        }
      }
    } catch (error) {}

    setUserPlan('VISITOR');
  };

  useEffect(() => {
    var authPages = ['/signup', '/auth', '/checkout'];
    var isAuthPage = false;
    for (var pageIndex = 0; pageIndex < authPages.length; pageIndex++) {
      if (location.pathname.indexOf(authPages[pageIndex]) === 0) {
        isAuthPage = true;
      }
    }
    if (!isAuthPage) {
      signInWithGoogleSDK('onCallback', handleLogin);
    }
  }, []);
  useEffect(() => {
    const fetchUserPlan = async () => {
      const { subscriptionPlan, subscriptionStatus } = await getUserPlan({
        apiBaseUrlV1,
      });
      setUserPlan(subscriptionPlan || 'VISITOR');
      const status = ['active', 'trialing', 'canceled'];
      setPlanStatus(
        status.includes(subscriptionStatus) ? subscriptionStatus : 'active',
      );
    };
    // use subscription plan from cookie if available (can be stale if user changed plan before token expiration date)
    handleLogin();
    // use subscription plan from permissions api
    fetchUserPlan();
  }, []);

  return (
    <>
      <Helmet>
        <script id="nav_init">
          {`(${initNavigationScript.toString()})();`}
        </script>
      </Helmet>

      <Nav
        env={isProd ? 'prod' : 'dev'}
        customerPlan={userPlan}
        subscriptionStatus={planStatus}
        onDemoClick={onDemoClick}
        onContactSupportClick={onContactSupportClick}
      />
    </>
  );
};

class NavbarComponent extends React.Component {
  render() {
    return (
      <StaticQuery
        query={detailsQuery}
        render={data => {
          const environment = data.site.siteMetadata.environment || null;
          const apiBaseUrlV1 = data.site.siteMetadata.apiBaseUrlV1 || null;
          return (
            <NavWrapper environment={environment} apiBaseUrlV1={apiBaseUrlV1} />
          );
        }}
      />
    );
  }
}
const detailsQuery = graphql`
  query DefaultSEOQuery2 {
    site {
      siteMetadata {
        environment
        apiBaseUrlV1
      }
    }
  }
`;

export default NavbarComponent;
